/**
 * ThaliaChat Service
 *
 * Self-Registration: Dieser Service registriert sich automatisch beim Import.
 * Consent-Modus: OHNE Usercentrics-Consent (requiresConsent: false)
 *
 * Um den Service zu entfernen: Einfach den gesamten thalia-chat Ordner löschen
 * und den Import in services/index.js entfernen.
 */
import serviceRegistry from "../ServiceRegistry";
import thaliaChatInteg from "./data-integ";
import thaliaChatProd from "./data-prod";

export { initThaliaChat };

// initThaliaChat läuft erst nach dem page_view-DataLayer-Event (siehe consent/index.js).
// Ein Klick auf einen "Chat öffnen"-Button (commandfor="nm_chat") kurz nach dem Seitenaufruf
// trifft #nm_chat sonst noch nicht an bzw. das von Novomind erzeugte #nm_chat_iframe existiert
// noch nicht - der Klick würde sonst stillschweigend verpuffen. Deshalb Wartezeit für einen
// solchen Fall in Sekunden, bevor aufgegeben wird.
const CHAT_READY_TIMEOUT_MS = 15000;

function initThaliaChat(dps) {
	const settings = dps.serviceSettings[dps.mandantId];
	if (!settings) {
		// mandanten-Filter und serviceSettings-Keys sollten immer übereinstimmen (siehe
		// data-integ.js/data-prod.js) - falls doch nicht (Tippfehler, neuer Mandant ohne
		// eigene Settings), sauber loggen statt mit TypeError abzubrechen.
		console.warn(`ThaliaChat: Keine serviceSettings für Mandant ${dps.mandantId}`);
		return;
	}
	const { jspUrl, frontendId, scriptSrc } = settings;

	window.NM = window.NM || {};
	window.NM.o = {
		jspURL: jspUrl,
		frontendID: frontendId
	};
	const script = document.createElement("script");
	script.src = scriptSrc;
	script.type = "text/javascript";
	script.async = 1;
	document.getElementsByTagName("head")[0].appendChild(script);
	registerInvokerEventListener();
}

function openServiceChat() {
	const iframe = document.getElementById("nm_chat_iframe");
	if (iframe?.contentWindow) {
		iframe.contentWindow.postMessage('increaseNMiFrame', '*');
		return true;
	}
	return false;
}

function registerInvokerEventListener() {
	// shell.js wird als klassisches <script> im <head> geladen und läuft synchron während
	// des HTML-Parsings - <body> existiert dann noch nicht. In diesem Fall bis DOMContentLoaded
	// warten, statt gegen ein nicht vorhandenes document.body zu appenden (würde die komplette
	// Consent-Service-Registrierung inkl. aller anderen Services abbrechen).
	if (!document.body) {
		document.addEventListener("DOMContentLoaded", registerInvokerEventListener, { once: true });
		return;
	}

	let chatElement = document.getElementById("nm_chat");

	if (!chatElement) {
		chatElement = document.createElement("div");
		chatElement.id = "nm_chat";

		let pendingObserver = null;

		const waitForChatIframeAndOpen = () => {
			if (pendingObserver) {
				return;
			}
			pendingObserver = new MutationObserver(() => {
				if (openServiceChat()) {
					pendingObserver.disconnect();
					pendingObserver = null;
				}
			});
			pendingObserver.observe(document.body, { childList: true, subtree: true });
			setTimeout(() => {
				if (pendingObserver) {
					pendingObserver.disconnect();
					pendingObserver = null;
				}
			}, CHAT_READY_TIMEOUT_MS);
		};

		chatElement.addEventListener("command", (event) => {
			if (event.command === "--open-service-chat" && !openServiceChat()) {
				// Novomind-Iframe existiert noch nicht (Service lädt noch) - Öffnen nachholen,
				// sobald es im DOM auftaucht, statt den Klick zu verlieren.
				waitForChatIframeAndOpen();
			}
		});

		document.body.appendChild(chatElement);
	}
}

// #nm_chat sofort beim Modulstart registrieren - unabhängig davon, wann/ob initThaliaChat
// läuft (siehe CHAT_READY_TIMEOUT_MS oben). So geht ein Klick auf den Chat-Button nicht
// verloren, nur weil der Service noch nicht bereit ist.
registerInvokerEventListener();

// Self-Registration beim Modulstart
serviceRegistry.registerService({
	name: "ThaliaChat",
	initFunction: initThaliaChat,
	requiresConsent: false, // Service lädt ohne Consent
	configs: [thaliaChatInteg, thaliaChatProd]
});
